// extracted by mini-css-extract-plugin
export default {"spaced":"LoadingComponent_spaced__d6poL","fullwidth":"LoadingComponent_fullwidth__uO7zR"};